import React from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import "./home.css";
import homepageBackground from "../media/homepageBackground.png";
import homepageImage1 from "../media/homepageImage1.jpeg";
import graphic1 from "../media/graphic1.jpeg";
import graphic2 from "../media/graphic2.png";
import graphic3 from "../media/graphic3.jpeg";
import graphic4 from "../media/graphic4.png";

function Home() {
  return (
    <div id="homepage-wrapper">
      <div id="intro">
        <img
          id="homepageBackground"
          src={homepageBackground}
          alt="homepagebackground"
        />
      </div>
      <div id="middle">
        <div id="image-left">
          <img id="homepageImage1" src={homepageImage1} alt="homepageImage1" />
        </div>
        <div id="text-right">
          <div id="first_para">
            <h2>
              <b> What is Period Poverty </b>
            </h2>
            <p>
              {" "}
              Period poverty refers not only to the lack of access to menstrual
              hygiene products but also to a lack of period education and basic
              sanitary services.{" "}
            </p>
          </div>
          <div id="para2">
            <h2>
              {" "}
              <b> Why We Care </b>{" "}
            </h2>
            <p>
              {" "}
              As a young woman myself, I believe that we need to take action
              against period poverty. It is immensely important and relevant
              that we don't stay quiet but take action and speak out on this
              global issue, which affects millions of girls each day.{" "}
            </p>
          </div>
          <div>
            <h2>
              {" "}
              <b> How to Use Our Website </b>{" "}
            </h2>
            <p>
              {" "}
              To tackle against the stigma and the effects of period poverty on
              girls and women, the PeriodFriend website provides 2 main tools:
              the donation service and education. With our platform for
              menstruators to request pad donations and educational resources
              for girls who may not have access to adequate menstrual hygiene
              management, we are taking one step at a time towards gender
              equity.{" "}
            </p>
          </div>
        </div>
      </div>
      <div id="bottom-content">
        <div id="row1">
          <div id="bottom1">
            <h4> Let’s talk about periods! </h4>
            <p>
              {" "}
              Period rights are human rights. Menstruation should not be a
              barrier for any woman. Safe Menstrual Hygiene Management is a
              basic human need for women, but sometimes it’s the last thing that
              gets paid for.
            </p>
            <img id="graphic1" src={graphic1} />
            <Button
              rightIcon={<ArrowForwardIcon />}
              colorScheme="pink"
              variant="outline"
            >
              Learn More
            </Button>
          </div>
          <div id="bottom2">
            <h4> What are we calling for? </h4>
            <p> Tackle period stigma and End Period Poverty</p>
            <img id="graphic1" src={graphic2} />
            <Button
              rightIcon={<ArrowForwardIcon />}
              colorScheme="pink"
              variant="outline"
            >
              Learn More
            </Button>
          </div>
        </div>
        <div id="row2">
          <div id="bottom3">
            <h4> Make the pledge </h4>
            <p>
              {" "}
              Let's all work to end period shame and encourage action. Do your
              part in making a pledge to support this cause today. We can all
              take action to end period shame and stigma!
            </p>
            <img id="graphic1" src={graphic3} />
            <Button
              rightIcon={<ArrowForwardIcon />}
              colorScheme="pink"
              variant="outline"
            >
              Pledge Here
            </Button>
          </div>
          <div id="bottom4">
            <h4> Share Your Story </h4>
            <p> Submit your experience about periods here </p>
            <img id="graphic1" src={graphic4} />
            <Button
              rightIcon={<ArrowForwardIcon />}
              colorScheme="pink"
              variant="outline"
            >
              Share Story
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
